import { styled } from "."

export const Paragraph = styled("p")({
  textAlign: "center",
})
